import React from 'react'
import { useSelector } from 'react-redux'
import FormInput from './FormInput'
import { components } from 'react-select'

export function SelectPayer(props){
  const { handleChange, handleNewPaymentOptionClick } = props
  const { payment_sources } = useSelector(state=>state.paymentSources)

  function getPayers(){
    var payers = []
    payment_sources.map(payment_source=>{
      payers.push({
        ...payment_source,
        label: `${payment_source.first_name} ${payment_source.last_name}`,
        value: payment_source.id
      })
    })
    return payers
  }

  const customOption = (props) => (
    <components.Option {...props}>
        <div>{props.data.label}</div>
        <div className="text-secondary" style={{color: 'rgba(0,0,0,0.5)'}}>{props.data.email}</div>
    </components.Option>
  )

  return(
    <div>
      <FormInput
        type="select"
        label='Payer'
        placeHolder="Select Payer..."
        handleChange={(e)=>handleChange(e)}
        options={getPayers()}
        components={{Option: customOption, SingleValue: customOption}}
        className="mb-0 pb-0"/>
      <button className="btn btn-sm btn-white p-0 text-info mb-3 mt-1" onClick={()=>handleNewPaymentOptionClick()}>Add New Payer</button>
    </div>
  )
}